/*
 * @Descripttion: Cylinder 封装
 * @version:
 * @Author: 周志国
 * @Date: 2025-09-08
 * @LastEditors: 周志国
 * @LastEditTime: 2025-09-15 10:43:49
 * @changeLog:
 * @FilePath: /anov-3d-webgl/packages/anov-3d-ability/src/business/Cylinder/index.ts
 */
import {
  CylinderGeometry,
  Mesh,
  MeshBasicMaterial,
} from '@anov/3d-core'
import _ from 'lodash'
import ObjectLayer from '../Base/ObjectLayer'
import { defineProps } from '../Utils/defineProps'
import type { options } from './types'
import type { ICylinder } from './interface'

export class Cylinder extends ObjectLayer implements ICylinder {
  private mesh!: Mesh
  private currentOptions!: options
  constructor(options: options, sceneControl?: any) {
    super(sceneControl)
    this.currentOptions = options
    this.mesh = this.createCylinder(this.currentOptions)
    this.add(this.mesh) // 添加到 ObjectLayer
    defineProps(
      this,
      ['radius', 'height', 'circleSegment', 'heightSegment', 'openEnded'],
      ['wireframe', 'color'],
      'updateCylinder',
    )
  }

  createCylinder(options: options): Mesh {
    const {
      radius = 1,
      height = 1,
      circleSegment = 16,
      heightSegment = 1,
      openEnded = false,
      material = {},
    } = options
    const geometry = new CylinderGeometry(
      radius,
      radius,
      height,
      circleSegment,
      heightSegment,
      openEnded,
    )
    geometry.translate(0, height / 2, 0)
    const defaultMat = {
      color: 0xFFFFFF,
      opacity: 1,
      transparent: false,
      wireframe: false,
      visible: true,
    }
    const mat = new MeshBasicMaterial({ ...defaultMat, ...material })
    return new Mesh(geometry, mat)
  }

  /** 更新Cylinder参数 */
  updateCylinder(options: options): void {
    if (!this.mesh)
      return
    _.mergeWith(this.currentOptions, options)
    this.remove(this.mesh)
    this.mesh.geometry.dispose();
    (this.mesh.material as any).dispose()
    this.mesh = this.createCylinder(this.currentOptions)
    this.add(this.mesh)
  }

  /** 销毁释放资源 */
  public destroy() {
    if (!this.mesh)
      return
    this.remove(this.mesh)
    this.mesh.geometry.dispose();
    (this.mesh.material as any).dispose()
    // @ts-ignore
    this.mesh = null
  }
}
